<template>
    <div>
        <el-form size="small" label-position="left" label-width="100px" class="lywidgetsetting" @submit.prevent>
            <el-collapse v-model="lyCollapseActiveList" class="lyformsetting-collapse">
                <el-collapse-item name="lyws01" title="组件属性">
                    <el-form-item label="字段标识">
                        <el-input  v-model.trim="optionModel.name" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="隐藏">
                        <el-switch v-model="optionModel.hidden" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="禁用">
                        <el-switch v-model="optionModel.disabled" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="是否链接按钮">
                        <el-switch v-model="optionModel.link" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="加载中状态">
                        <el-switch v-model="optionModel.loading" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="显示类型">
                        <el-select v-model="optionModel.type" filterable @change="handleChange">
                            <el-option label="default" value=""></el-option>
                            <el-option label="primary" value="primary"></el-option>
                            <el-option label="success" value="success"></el-option>
                            <el-option label="warning" value="warning"></el-option>
                            <el-option label="danger" value="danger"></el-option>
                            <el-option label="info" value="info"></el-option>
                            <el-option label="text" value="text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标签文本">
                        <el-input v-model="optionModel.label"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="标签宽度">
                        <el-input v-model="optionModel.labelWidth"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="隐藏字段标签">
                        <el-switch v-model="optionModel.labelHidden" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="按钮文本">
                        <el-input v-model="optionModel.buttonText"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="组件大小">
                        <el-select v-model="optionModel.size" @change="handleChange">
                            <el-option v-for="item in formSizes" :key="item.value" :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <customClassLy :selected-widget="selectedWidget" :option-model="optionModel"></customClassLy>
                    <el-form-item label-width="0">
                        <el-divider>高级属性</el-divider>
                    </el-form-item>
                    <el-form-item label="朴素按钮">
                        <el-switch v-model="optionModel.plain" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="圆角按钮">
                        <el-switch v-model="optionModel.round" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="圆形按钮">
                        <el-switch v-model="optionModel.circle" @change="handleChange"></el-switch>
                    </el-form-item>
                    <el-form-item label="按钮图标(组件)">
                        <el-input v-model="optionModel.icon"  style="width: 100%" @change="handleChange"></el-input>
                    </el-form-item>
                    <el-form-item label="自定义按钮颜色">
                        <el-color-picker v-model="optionModel.color" @change="handleChange" />
                    </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="lyws02" title="事件属性" v-if="showEventCollapse">
                    <el-form-item label="onClick" label-width="150px">
                        <el-button type="info" icon="edit" plain round @click="editFormEventHandler('onClick',[])">编写代码</el-button>
                    </el-form-item>
                </el-collapse-item>
            </el-collapse>
            <lyDialog v-model="showFormEventDialog" title="组件事件" width="60%" top="20px" :before-close="handleFormEventHandlerClose">
                <div>
                    <el-alert :title="currentEventNameTitle" type="info" :closable="false" />
                    <lyCodeEditor ref="lyFormEditCss" v-model="formEventCode" mode="javascript" height="600" :read-only="false"></lyCodeEditor>
                    <el-alert title="}"  :closable="false" type="info"></el-alert>
                </div>
                <template v-slot:footer>
                    <el-button @click="handleFormEventHandlerClose" size="default">关闭</el-button>
                    <el-button type="primary" @click="saveFormEvent" size="default">确定</el-button>
                </template>
            </lyDialog>
        </el-form>
    </div>
</template>

<script setup>
    import {ref, onMounted, reactive, computed, watch,defineAsyncComponent} from 'vue'
    import { useBuilderStore } from "@/store/lyFormBuilder";
    import validationCommonLy from "@/components/lyform-builder/lysetting-pannel/lywidget-common/validation-common-ly"
    import customClassLy from "@/components/lyform-builder/lysetting-pannel/lywidget-common/custom-class-ly"
    import lyDialog from '@/components/dialog/dialog'
    const lyCodeEditor = defineAsyncComponent(() => import('@/components/lyform-builder/code-editor'));

    const props = defineProps({
        selectedWidget: Object,
        optionModel: Object,
        builderConfig :{
            type:Object,
            default:{
                showHeader:true,//是否显示头部信息
                showFormTemplates:true,//是否显示表单模板
                showEventCollapse:true,//是否显示组件事件属性折叠面板
                showDocumentButton:true,//是否显示文档按钮
                clearDesignerButton: true,  //是否显示清空设计器按钮
                previewFormButton: true,  //是否显示预览表单按钮
                exportJsonButton: true,  //是否显示导出JSON器按钮
                exportCodeButton: true,  //是否显示导出代码按钮
                importJsonButton:true, //是否显示导入代码按钮
                showFullButton: true,  //是否显示全屏按钮
                openNewWindowButton: true,  //是否显示新窗口按钮
                saveFormButton:true, //是否保存表单按钮
                showCrudSettings:true,//是否显示组件和表单的crud属性配置
            }
        },
    })
    const builderStore = useBuilderStore()
    function handleChange(newValue) {
         builderStore.saveCurrentHistoryStep()
    }
    let lyCollapseActiveList =  ref(['lyws01','lyws02','lyws03'])
    const formSizes = ref([
        {label: 'default', value: ''},
        {label: 'large', value: 'large'},
        {label: 'small', value: 'small'},
    ])
    function showEventCollapse(){
        if (builderStore.builderConfig['showEventCollapse'] === undefined) {
          return true
        }
        return !!builderStore.builderConfig['showEventCollapse']
    }

    function deleteOption(option, index) {
        props.optionModel.optionItems.splice(index, 1)
        builderStore.emitHistoryChange()
    }

    function addOption() {
        let newValue = props.optionModel.optionItems.length + 1
        props.optionModel.optionItems.push({
          value: newValue,
          label: 'new option'
        })
        builderStore.emitHistoryChange()
    }

    let currentEventName = ref("")//编辑选中当前事件名称
    let currentEventNameTitle = ref("")//编辑框提示事件函数全名
    let showFormEventDialog = ref(false)
    let formEventCode = ref("")
    function editFormEventHandler(flag,eventParamsName){//flag事件名、eventParamsName事件回调参数名使用数组[]
        currentEventName.value = flag
        currentEventNameTitle.value = `${props.optionModel.name}.${flag}(${eventParamsName.join(', ')}) {`
        formEventCode.value = props.selectedWidget.options[flag] || ''
        showFormEventDialog.value = true
    }
    function handleFormEventHandlerClose(){
        showFormEventDialog.value = false
    }
    function saveFormEvent(){
        builderStore.selectedWidget.options[currentEventName.value] = formEventCode.value
        builderStore.saveCurrentHistoryStep()
        showFormEventDialog.value = false
    }

</script>

<style lang="scss" scoped>
    .lywidgetsetting{
        ::v-deep(.el-form-item__label) {
          font-size: 13px;
          overflow: hidden;
          white-space: nowrap;
        }
        .lyformsetting-collapse{
            ::v-deep(.el-collapse-item__header) {
                font-weight: bold;
            }
        }
    }

</style>